<template>
  <div
    class="custom-control custom-checkbox"
    :class="{
      'customize': placement === 'check-participant-name-canvas',
    }"
  >
    <input
      :id="placement"
      v-model="slideActive.metadata.autoFillParticipantName"
      type="checkbox"
      class="custom-control-input"
      @change="toggleAutofillParticipantNames()"
    >
    <label
      class="custom-control-label"
      :for="placement"
    >
      {{ participantNameAutofillText }}
    </label>
    <span class="pl-1 title-table-presentation-tooltip">
      <b-button
        v-tooltip="automaticallyAddedText"
        class="tooltip-btn"
      />
      <i class="fas fa-question-circle" />
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import Socket from '@/socket'
import slideApi from '@/api/slide'

import Utils from '@/util'

// api
import eventCategories from '@/constant/eventCategories'
import EventBus from '@/eventBus'

const DEFAULT_SETTING_PLACEMENT = 'check-participant-name-setting'

export default {
  props: {
    placement: {
      type: String,
      default: DEFAULT_SETTING_PLACEMENT,
      validator: (value) => {
        return ['check-participant-name-setting', 'check-participant-name-canvas'].includes(value)
      },
    },
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
    automaticallyAddedText() {
      if (this.placement === DEFAULT_SETTING_PLACEMENT) {
        return this.$i18nPresenter.t('automatically_added_to_the_wheel')
      }

      return this.$t('automatically_added_to_the_wheel')
    },
    participantNameAutofillText() {
      if (this.placement === DEFAULT_SETTING_PLACEMENT) {
        return this.$i18nPresenter.t('participant_name_autofill')
      }

      return this.$t('participant_name_autofill')
    },
  },
  created() {
    if (!this.slideActive.metadata) {
      this.updateSlideActiveAction({
        metadata: {},
      })
    }
  },
  methods: {
    async toggleAutofillParticipantNames() {
      const payload = {
        accessCode: this.presentation.uniqueAccessCode,
        metadata: {
          ...this.slideActive.metadata,
          autoFillParticipantName: this.slideActive.metadata.autoFillParticipantName,
        },
        presenting: this.$store.getters.isPresenting,
        socketId: Socket.getSocketId(),
      }
      this.$store.dispatch('setSyncPresentation', 1)
      try {
        await slideApi.updateSlideById(this.slideActive.id, payload)
        const index = this.presentation.slides.findIndex((item) => {
          return item.id === this.slideActive.id
        })
        if (index !== -1) {
          this.presentation.slides[index].metadata = this.slideActive.metadata
        }
        this.$store.dispatch('setSyncPresentation', 2)
      } catch (error) {
        this.$store.dispatch('setSyncPresentation', 3)
        Sentry.captureException(error)
      }

      this._track(payload.metadata.autoFillParticipantName)

      EventBus.$emit('updateEntries')
    },

    _track(value) {
      const eventActionFrom = this.placement === DEFAULT_SETTING_PLACEMENT
        ? 'Setting'
        : 'Canvas'

      Utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        `${eventActionFrom} > Spinner Wheel > Participant name autofill: ${value}`,
        null,
        null,
        {
          presentationId: this.presentation.id,
          slideId: this.slideActive.id,
        },
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-control {
  display: flex;
  align-items: center;
  padding-left: 0;

  &-label {
    display: inline-block;
    max-width: 100%;
    padding-left: 1.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.customize {
    .custom-control-label {
      margin-left: -1rem;
    }
  }

  &-label::before,
  &-label::after {
    left: 0;
  }
}
</style>
